export default __webpack_public_path__ + "static/perkins-coie-90e9ff54f2e36ccdf7e34e553fa72390.svg";